import { Component } from '@angular/core';
import { SkeletonComponent } from '@esolutions/design-system-ng/components';

@Component({
  selector: 'app-my-learning-placeholder',
  templateUrl: './my-learning-placeholder.component.html',
  styleUrls: ['./my-learning-placeholder.component.scss'],
  imports: [SkeletonComponent],
  standalone: true
})
export class MyLearningPlaceholderComponent {}
